import {get, post, del, patch, download} from "../api"
import * as url from "../url"
import {format} from "react-string-format";

const apiGetFilesFilter = data => {
  return get(url.API_FILES + "filter/", data.history)
}

const apiPostFilesSegments = data => {
  return post(url.API_FILES + "segments/", data.history, data.data)
}

const apiGetFilesList = data => {
  return post(url.API_FILES + "list/", data.history, data.data)
}

const apiGetFilesProcessRefresh = data => {
  return get(url.API_FILES + "process-refresh/" + data.data.sign + "/", data.history)
}

const apiPostFilesSlipQRUpdate = data => {
  return post(format(url.API_SLIP_DETAIL, data.sign) + "qr-update/", data.history, data.data)
}

const apiDeleteFilesDelete = data => {
  return del(url.API_FILES + data.sign + "/destroy/", data.history)
}

const apiDownloadFilesDownload = data => {
  return download(url.API_FILES + "download/" + data.sign, data.history, data.filename)
}

const apiDownloadFilesSlipMKSoftDownload = data => {
  return download(format(url.API_SLIP + "mksoft-export/{0}/{1}/{2}/{3}/", data.data.sectionId, data.data.segmentId, data.data.year, data.data.month), data.history, "slips.csv")
}

const apiDownloadFilesInvoiceIssuedMKSoftDownload = data => {
  return download(format(url.API_INVOICE + "mksoft-issued-export/{0}/{1}/{2}/{3}/", data.data.sectionId, data.data.segmentId, data.data.year, data.data.month), data.history, "invoices_issued.csv")
}

const apiDownloadFilesDeliveredIssuedMKSoftDownload = data => {
  return download(format(url.API_INVOICE + "mksoft-delivered-export/{0}/{1}/{2}/{3}/", data.data.sectionId, data.data.segmentId, data.data.year, data.data.month), data.history, "invoices_delivered.csv")
}

export {
  apiGetFilesFilter,
  apiPostFilesSegments,
  apiGetFilesList,
  apiGetFilesProcessRefresh,
  apiPostFilesSlipQRUpdate,
  apiDeleteFilesDelete,
  apiDownloadFilesDownload,
  apiDownloadFilesSlipMKSoftDownload,
  apiDownloadFilesInvoiceIssuedMKSoftDownload,
  apiDownloadFilesDeliveredIssuedMKSoftDownload,
}
